// src/lib/razorpay.js
// Loads Razorpay Checkout on demand and opens the payment sheet.
// The SDK is served from checkout.razorpay.com — injected once, then reused.

export function loadRazorpay() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const existing = document.getElementById("razorpay-sdk");
    if (existing) {
      existing.addEventListener("load", () => resolve(true));
      existing.addEventListener("error", () => resolve(false));
      return;
    }
    const s = document.createElement("script");
    s.id = "razorpay-sdk";
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

// options: { key, amount(paise), currency, orderId, name, description, prefill }
// Resolves with the Razorpay success response; rejects if the user closes the sheet.
export async function openCheckout({
  key,
  amount,
  currency = "INR",
  orderId,
  name = "Karvi AI",
  description = "",
  prefill = {},
}) {
  const ok = await loadRazorpay();
  if (!ok) throw new Error("Couldn't load the payment SDK — check your connection.");

  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key,
      amount,
      currency,
      order_id: orderId,
      name,
      description,
      prefill,
      theme: { color: "#9333EA" },
      handler: (resp) => resolve(resp),
      modal: { ondismiss: () => reject(new Error("Payment cancelled")) },
    });
    rzp.open();
  });
}
